import React, { ReactElement, useMemo } from 'react';
import { Appointment } from 'types/appointments';
import { AppointmentSlotStyle } from './calendar.styled';
import { DateTimeToMinuteOnlyISOString } from '../../../../utils/dateUtil';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import {
  NO_FREE_APPOINTMENTS,
  useAppointmentOnlineStaffOnlySplit,
} from '../../../../containers/staff/calendar/./common/useAppointmentOnlineStaffOnlySplit';
import { APPOINTMENT_STATUS_FREE } from '../../../../types/appointmentsConst';

interface Props {
  appointments: Appointment[];
  handleClickTimeSlot: (slot: DateTimeToMinuteOnlyISOString) => void;
  timeslotDateISO: DateTimeToMinuteOnlyISOString;
  isSelected?: boolean;
}

const CalendarAppointmentSlot = ({
  isSelected,
  appointments,
  handleClickTimeSlot,
  timeslotDateISO,
}: Props): ReactElement => {
  const { t } = useCommonTranslation();

  const freeAppts = useMemo(
    () => appointments.filter((a) => a.status === APPOINTMENT_STATUS_FREE),
    [appointments],
  );
  const { onlineSplitStatus, freeOnlineAppointments, freeStaffAppointments } =
    useAppointmentOnlineStaffOnlySplit({ appointments: freeAppts });

  const hasFreeAppointments = onlineSplitStatus !== NO_FREE_APPOINTMENTS;

  const hoverTitle =
    onlineSplitStatus === 'ONLINE_AND_STAFF_AVAILABLE'
      ? t('calendar-slot-breakdown-hover', {
          reservedForStaff: freeStaffAppointments.length,
        })
      : undefined;
  return (
    <AppointmentSlotStyle
      slotType={isSelected ? 'SELECTED' : onlineSplitStatus}
      type="button"
      title={hoverTitle}
      onClick={() =>
        hasFreeAppointments && handleClickTimeSlot(timeslotDateISO)
      }
    >
      {freeStaffAppointments.length + freeOnlineAppointments.length}
    </AppointmentSlotStyle>
  );
};
export default CalendarAppointmentSlot;
